import { isUndefined } from 'lodash';
import axios from 'src/utils/axios';
import logger from 'src/utils/logger';
import parse from 'src/utils/parse';

class PimApis {
  async getCatalogues(
    page: number,
    pageSize: number,
    search?: any,
    selectedSort?: any,
    isActiveParam?: any
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const params: any = {
        page,
        pageSize,
        isActive: isActiveParam,
      };

      if (search) {
        params.search = search;
      }

      if (selectedSort?.id && selectedSort?.value) {
        params.column = selectedSort.id;
        params.sort = selectedSort.value === 'desc' ? -1 : 1;
      }

      axios
        .get(`${process.env.REACT_APP_PIM_URL}/catalogues`, { params })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error: Error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }

  async addCatalogue(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PIM_URL}/catalogues`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async uploadCatalogueFile(formData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PIM_URL}/catalogues/uploadFile`, formData)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async updateCatalogue(catalogueId: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${process.env.REACT_APP_PIM_URL}/catalogues/${catalogueId}`,
          payload
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /// //////// Categories Apis ///////////////
  async getCategories(
    page: number,
    pageSize: number,
    search?: any,
    selectedSort?: any,
    isActiveParam?: any,
    productCatalgId?: any
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const params: any = {
        page,
        pageSize,
        isActive: isActiveParam,
        productCatalogueId: productCatalgId
      };

      if (search) {
        params.search = search;
      }

      if (selectedSort?.id && selectedSort?.value) {
        params.column = selectedSort.id;
        params.sort = selectedSort.value === 'desc' ? -1 : 1;
      }

      axios
        .get(`${process.env.REACT_APP_PIM_URL}/category`, { params })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error: Error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }

  async getAllCategories(
    page: number,
    pageSize: number,
    search?: any,
    selectedSort?: any,
    isActiveParam?: any,
    productCatalgId?: any
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const params: any = {
        page,
        pageSize,
        isActive: isActiveParam,
        productCatalogueId: productCatalgId
      };

      if (search) {
        params.search = search;
      }

      if (selectedSort?.id && selectedSort?.value) {
        params.column = selectedSort.id;
        params.sort = selectedSort.value === 'desc' ? -1 : 1;
      }

      axios
        .get(`${process.env.REACT_APP_PIM_URL}/category/all`, { params })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error: Error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }




  async addCategory(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PIM_URL}/category`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async updateCategory(categoryId: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${process.env.REACT_APP_PIM_URL}/category/${categoryId}`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async uploadCategoryFile(catalogueId, formData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PIM_URL}/category/uploadFile`, formData, {
          params: { catalogueId },
        })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /// //////// Products Apis ///////////////
  async getProducts(
    page: number,
    pageSize: number,
    categoryId: string,
    search?: any,
    selectedSort?: any,
    isActiveParam?: any,
    from?: any,
    to?: any
  ): Promise<any> {

    return new Promise((resolve, reject) => {
      const params: any = {
        page,
        pageSize,
        categoryId,
        isActive: isActiveParam,
        from,
        to,
      };

      if (search) {
        params.search = search;
      }

      if (selectedSort?.id && selectedSort?.value) {
        params.column = selectedSort.id;
        params.sort = selectedSort.value === 'desc' ? -1 : 1;
      }

      axios
        .get(`${process.env.REACT_APP_PIM_URL}/product`, { params })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error: Error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }

  async getProductsByCategorya(
    page: number,
    pageSize: number,
    categoryId: string,
    search?: any,
    selectedSort?: any,
    isActiveParam?: any,
    from?: any,
    to?: any
  ): Promise<any> {

    return new Promise((resolve, reject) => {
      const params: any = {
        page,
        pageSize,
        isActive: isActiveParam,
        from,
        to,
      };

      if (search) {
        params.search = search;
      }




        if (selectedSort?.id && selectedSort?.value) {
          params.column = selectedSort.id;
          params.sort = selectedSort.value === 'desc' ? -1 : 1;
        }

        const url = `${process.env.REACT_APP_PIM_URL}/product/getProductByCategoryId/${categoryId}`;

        axios
          .get(url, { params })
          .then((response) => {
            response = parse(response);
            if (!isUndefined(response?.data)) {
              resolve(response);
            } else {
              reject(new Error('Internal Server Error'));
            }
          })
          .catch((error: Error) => {
            logger(error, 'error');
            reject(new Error('Internal Server Error'));
          });
      });
  }


  async getProductHistory(productId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const params: any = {
        page: 0,
        pageSize: 1000,
      };
      // http://192.168.0.101:8888/pimlogs/product/6752fc8136a1906595059ddd
      axios
        // .get(`${process.env.REACT_APP_PIM_URL}/product/logs/${productId}`, {params}
        // http://192.168.0.101:8888/pimlogs/product/6752fc8136a1906595059ddd
        .get(`${process.env.REACT_APP_PIM_URL}/pimlogs/product/${productId}`,)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error: Error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }


  async getProductHeader(tempid: string): Promise<any> {
    return new Promise((resolve, reject) => {

      axios
        .get(`${process.env.REACT_APP_PIM_URL}/product_template/${tempid}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error: Error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }











  async addProduct(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PIM_URL}/product`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async updateProduct(productId: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${process.env.REACT_APP_PIM_URL}/product/${productId}`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async uploadProductFile(categoryId, formData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_PIM_URL}/product/uploadProductFile`,
          formData,
          {
            params: { categoryId },
          }
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async getAutoCompleteDistributer(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_PIM_URL}/autoComplete/distributor`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async getAutoCompleteCategories(): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_PIM_URL}/autoComplete/category`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export const pimApis = new PimApis();
